import 'client-only';

import { useMemo } from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import type {
  CheckoutData,
  ProductSelectionData,
} from '@/services/productSelectionAndCheckoutService/server';

type CommonData = Pick<
  ProductSelectionData,
  Extract<keyof CheckoutData, keyof ProductSelectionData>
>;

export const useNullableProductSelectionAndCheckoutCommonData = () => {
  const data = useDataProvider();

  return useMemo(() => {
    const commonData = {
      ...data?.checkout,
      ...data?.productSelection,
    } as CommonData;

    return Object.keys(commonData).length === 0 ? null : commonData;
  }, [data]);
};

export const useProductSelectionAndCheckoutCommonData = () => {
  const commonData = useNullableProductSelectionAndCheckoutCommonData();

  if (!commonData) {
    throw new Error(
      'useReccomendationAndCheckoutCommonData can only be used within an instance of DataProvider which provides either productSelection or checkout data.',
    );
  }

  return commonData;
};
